import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UtilService} from '../../services/util.service';

@Component({
    selector: 'app-custom-tooltip',
    templateUrl: './custom-tooltip.component.html',
    styleUrls: ['./custom-tooltip.component.scss']
})
export class CustomTooltipComponent implements OnInit, OnChanges {

    @Input() type: string;
    @Input() tooltips: any[];
    @Input() key: string;
    @Input() position: any;
    @Input() tooltip: string;
    @Input() tooltipClass: string;
    icon: string;
    content: string;
    ariaLabel: string;

    constructor() {
    }

    ngOnInit() {
        this.position = this.position || 'after';
        switch (this.type) {
            case 'INFO':
                this.icon = 'icon ic-icon_info';
                break;
            case 'TEXTBLOCK':
                this.icon = 'icon ic-icon_textbaustein';
                break;
            case 'QUESTION':
                this.icon = 'icon ic-icon_hilfestellung';
                break;
            case 'PDF':
                this.icon = 'icon icon-ic_pdf';
                break;
            default:
                this.icon = 'icon ic-icon_info';
        }
        if (this.tooltips !== null) {
            this.getTooltipContent();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tooltips !== undefined) {
            this.tooltips = changes.tooltips.currentValue;
            this.getTooltipContent();
        }
    }

    private getTooltipContent() {
        if (this.tooltip) {
            this.content = this.tooltip;
        } else {
            const obj = UtilService.getObjectByValue('tooltipId', this.key, this.tooltips);
            if (obj !== undefined) {
                this.content = obj.content;
                this.ariaLabel = obj.name;
            }
        }
    }
}
